import { render, staticRenderFns } from "./HomePageTemplate.vue?vue&type=template&id=71b48692&scoped=true"
import script from "./HomePageTemplate.vue?vue&type=script&lang=js"
export * from "./HomePageTemplate.vue?vue&type=script&lang=js"
import style0 from "./HomePageTemplate.vue?vue&type=style&index=0&id=71b48692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b48692",
  null
  
)

export default component.exports